module.exports = __webpack_public_path__ + "img/DigitalSHMSystem_Login_top.c559f575.svg";